import PriceRangeFilter from './components';

export {
    PriceRangeFilter as default
};



// WEBPACK FOOTER //
// ./src/js/modules/PriceRangeFilter/index.js